// extracted by mini-css-extract-plugin
export default {"customAccordion":"style_customAccordion__lXXta","container":"style_container__fT-kJ","body":"style_body__SSyoh"};